var render = function () {
  var _vm$config, _vm$config2, _vm$config3;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "446",
      "content-class": "white"
    },
    model: {
      value: _vm.congratulations,
      callback: function callback($$v) {
        _vm.congratulations = $$v;
      },
      expression: "congratulations"
    }
  }, [_c('v-layout', {
    staticClass: "text-center px-16px pt-52px pb-40px",
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('h2', {
    staticClass: "tit tit--lg lightblue--text mb-6px"
  }, [_vm._v(" 당첨을 "), _c('br'), _vm._v(" 축하합니다! ")]), _c('v-img', {
    staticClass: "mb-6 mb-md-8",
    attrs: {
      "src": (_vm$config = _vm.config) === null || _vm$config === void 0 ? void 0 : _vm$config.image2,
      "max-width": "100%",
      "width": "414",
      "aspect-ratio": 414 / 224
    }
  }), _c('h3', {
    staticClass: "tit mb-1"
  }, [_vm._v(" " + _vm._s((_vm$config2 = _vm.config) === null || _vm$config2 === void 0 ? void 0 : _vm$config2.name) + " ")]), [1, 2].includes((_vm$config3 = _vm.config) === null || _vm$config3 === void 0 ? void 0 : _vm$config3.ranking) ? _c('p', {
    staticClass: "txt grey-94--text font-weight-bold"
  }, [_vm._v(" 당첨관련 안내를 위해 개별적으로 연락드릴 예정입니다. ")]) : _vm._e(), _c('v-btn', {
    staticClass: "white--text mt-6 mt-md-8",
    attrs: {
      "to": "/mypage/event",
      "color": "#59B6E5",
      "dark": ""
    }
  }, [_vm._v("마이페이지 바로가기")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }